import type { FaireProductEntity } from "../../entity_types/product";

export const p_8qhvghbf8t: FaireProductEntity = {
  token: "p_8qhvghbf8t",
  type: "product",
  name: "Cup candy Neon Gummy Worm Fun fruit Bites 6oz",
  brandToken: "b_p3ed87kb2a",
  brandName: "SaniLLC",
  imageUrl:
    "https://cdn.faire.com/fastly/852513d9366696ff4ea5f967dd65f5f7ac2c2abaed56ce3ab103ec160fa95610.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57c0afb8c11a97a4d10aed5b91cdef0444686b91c123fb3e60cd95fc8c5b19e6.jpeg",
    "https://cdn.faire.com/fastly/133f2ba687a5d55004fc93442cb9843a251a42b247d7ef2d7f5329d272729a21.jpeg",
    "https://cdn.faire.com/fastly/c7cd452cdf0f0629da07bc8f1c50e9b7594e40c90297928b7a0bd6377b897536.jpeg",
    "https://cdn.faire.com/fastly/d16f87bb2f44b21c120142b33eb3678564bfe09daf827e942b102a72d205544b.jpeg",
    "https://cdn.faire.com/fastly/de38428675f42a1bdd21e570390cb68c612531d7255caca83fa989eb8c388750.jpeg",
    "https://cdn.faire.com/fastly/0e924dd6a57df1d4b00f3d7070c049655b3cb04a360b0b18fb86a2d8179413b8.png",
  ],
  priceDollars: 31.39,
  description:
    "cup Candy Neon Gummy Worm Fun Fruit Bites - 6oz\n\nBrighten up your snacking with cup Candy Neon Gummy Worm Fun Fruit Bites! These vibrant, neon-colored gummy Worms are packed with juicy fruit flavors and a soft, chewy texture that everyone loves. Fun to look at and even better to eat, theyâ€™re the perfect treat for any occasion!\n\n * \nSize: 6oz\n\n * \nBold neon colors and fruity flavors\n\n * \nSoft, chewy, and delicious\n\n * \nPerfect for parties, goodie bags, or everyday snacking\n\n * \nA fun favorite for kids and adults\n\nLight up your taste buds with the colorful fun of cup Candy Neon Gummy Worm Fun Fruit Bites sweet, playful, and totally irresistible!\n",
  tags: [],
  msrpDollars: 39.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:54.473Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
